<template>
  <Applications />
</template>

<script>
import Applications from '../components/Applications.vue';

export default {
  components: {
    Applications,
  },
  data() {
    return {
      disableCard: false,
    };
  },
}
</script>
